const koelMethodes = [
  "Airco of ventilator",
  "Gordijnen sluiten (overdag)",
  "Ramen open (overdag)",
  "Ramen open ('s nachts)",
  "Zoeken verkoeling in de buurt",
  "Zonwering"
];

const coolingMethods = [
  ["AC or ventilator", '<span class="material-symbols-outlined"> mode_fan</span> AC or ventilaiton'],
  ["Blinds", '<span class="material-icons">blinds</span> Blinds'],
  ["Curtains closed (day)", "<span class=\"material-icons\">curtains_closed</span> Curtains closed (day)"],
  ["Find cool area", "<span class=\"material-symbols-outlined\">air</span> Cool area"],
  ["Open windows (day)", "<span class=\"material-symbols-outlined\">sunny</span> Open windows (day)"],
  ["Open windows (night)", "<span class=\"material-symbols-outlined\">clear_night </span> Open windows (night)"]
];

const coolingEnglishToDutch = {
  "AC or ventilator": "Airco of ventilator",
  "Blinds": "Zonwering",
  "Curtains closed (day)": "Gordijnen sluiten (overdag)",
  "Find cool area": "Zoeken verkoeling in de buurt",
  "Open windows (day)": "Ramen open (overdag)",
  "Open windows (night)": "Ramen open ('s nachts)"
};

module.exports = {koelMethodes, coolingMethods, coolingEnglishToDutch};